import styled from 'styled-components';

export const MomentsDescription = styled.p`
  margin: 0;
  margin-bottom: 15px;
  padding: 0;
  
  font-size: 16px;
  line-height: 19px;
  color: ${({ theme }) => theme.black};
  
  a {
    font-weight: 600;
    color: ${({ theme }) => theme.blue};
    
    transition: color 0.3s;
    
    &:hover {
      color: ${({ theme }) => theme.black};
    }
  }
`;
